import { Create, SimpleForm, type CreateProps } from "react-admin";
import { HouseVisitEventFormFields } from "./HouseVisitEventFormFields";
import { redirectToHouseVisitDashboard } from "../redirect-to-house-visit-dashboard";

export const HouseVisitEventCreate = (props: CreateProps) => (
  <Create {...props} redirect={redirectToHouseVisitDashboard()}>
    <SimpleForm warnWhenUnsavedChanges sx={{ maxWidth: { xs: "100%", sm: 560 } }}>
      <HouseVisitEventFormFields />
    </SimpleForm>
  </Create>
);
